import { createAction } from '@reduxjs/toolkit';

const saveServiceFormValues = createAction(
  'ui/sealink/journey/saveServiceFormValues'
);

const saveOriginalServiceFormValues = createAction(
  'ui/sealink/journey/saveOriginalServiceFormValues'
);

const saveDepartureServiceForm = createAction(
  'ui/sealink/journey/saveDepartureServiceForm'
);

const saveReturnServiceForm = createAction(
  'ui/sealink/journey/saveReturnServiceForm'
);

export {
  saveServiceFormValues,
  saveOriginalServiceFormValues,
  saveDepartureServiceForm,
  saveReturnServiceForm,
};
